import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useCountries = () => useQuery({ queryKey: [`loc-countries`], queryFn: async () => {
    const callback = await API.get(`/common/loc/countries`)
    return callback?.data
}, staleTime: 1000 * 60 * 60 * 24 * 7 , gcTime: 1000 * 60 * 60 * 24 * 14 })

export default useCountries